module.exports = __webpack_public_path__ + "static/media/verticaldots.61f10b1e.svg";